import { isNumber } from "lodash-es";

import { RuntimeParseError } from "@/domains/errors";
import { _extractArrayFromObject } from "@/modules/object/extractors/extractArray";

export const _extractNumberArrayFromObject = (value: unknown, prop: string): number[] => {
  const extractedValue = _extractArrayFromObject(value, prop);

  const extractedValues = extractedValue.map(val => {
    if (!isNumber(val)) {
      throw new RuntimeParseError({
        message: "[_extractNumberArrayFromObject] extractedValue in array was not a number.",
        info: {
          extractedValue,
          value,
          prop,
        },
      });
    }

    return val;
  });

  return extractedValues;
};
